
import React from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'

const Certificate = () => {
  return (
    <div>
      <Newnavbar />

      <div className="bg-[#FFFDF5] min-h-screen px-4 md:px-12 py-12 text-[#1F1F1F] font-sans">
        <div className="max-w-4xl mx-auto">
          <div className='trust_below_des flex flex-col justify-center items-center'>
            <p className="md:!text-[48px] md:py-[48px] py-[20px] !text-[24px] !font-bold !text-gray-900 text-center">
              Certifcate
            </p>
            
            <div className="certification_content flex flex-col items-center space-y-8 mt-10">
              <a 
                href="/iso.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex flex-col items-center hover:scale-105 transition-transform duration-300"
              >
                <div className="bg-white p-6 rounded-2xl shadow-lg flex flex-col items-center border border-gray-100">
                  <svg width="100px" height="100px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23 1v18h-3v-1h2V2H2v16h8v1H1V1zm-7 2H8v1h8zm-2 3V5h-4v1zm-7 5H3v1h4zm0 2H3v1h4zm-4 3h2v-1H3zm14-3a2 2 0 1 1-2-2 2.002 2.002 0 0 1 2 2zm-1 0a1 1 0 1 0-1 1 1.001 1.001 0 0 0 1-1zm.002-4.293a.965.965 0 0 0 1.32.55 1.08 1.08 0 0 1 1.213.207 1.066 1.066 0 0 1 .21 1.21.966.966 0 0 0 .548 1.324 1.064 1.064 0 0 1 0 2.004.965.965 0 0 0-.549 1.323A1.05 1.05 0 0 1 18 16.816v7.046l-3-2.538-3 2.538v-7.046a1.05 1.05 0 0 1-.744-1.49.965.965 0 0 0-.549-1.324 1.064 1.064 0 0 1 0-2.004.966.966 0 0 0 .549-1.324 1.066 1.066 0 0 1 .209-1.21 1.08 1.08 0 0 1 1.212-.206.965.965 0 0 0 1.32-.551 1.064 1.064 0 0 1 2.005 0zm.998 13v-5.04a.93.93 0 0 0-.998.625 1.064 1.064 0 0 1-2.004 0 .93.93 0 0 0-.998-.625v5.039l2-1.692zm-1.94-4.749a1.967 1.967 0 0 1 1.853-1.308 2.12 2.12 0 0 1 .87.197l.058-.091a1.964 1.964 0 0 1 1.116-2.695v-.122a1.966 1.966 0 0 1-1.116-2.695l-.087-.084a1.965 1.965 0 0 1-2.694-1.117h-.12a1.965 1.965 0 0 1-2.694 1.117l-.087.084a1.966 1.966 0 0 1-1.116 2.695v.122a1.964 1.964 0 0 1 1.116 2.695l.058.09a2.12 2.12 0 0 1 .87-.196 1.967 1.967 0 0 1 1.853 1.308L15 17z" fill="#1F1F1F"/>
                    <path fill="none" d="M0 0h24v24H0z"/>
                  </svg>
                  <h3 className="mt-4 text-xl font-bold text-gray-900">ISO/IEC 27001:2022</h3>
                  <p className="text-gray-600 mt-2">Information Security Management System</p>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-16 space-y-6 text-[16px] leading-relaxed text-gray-700">
            <p>
              At PayNeft, security is at the core of everything we do. Our ISO/IEC 27001:2022 Certificate demonstrates our commitment to the highest standards of information security.
            </p>
            <p>
              This international standard specifies the requirements for establishing, implementing, maintaining, and continually improving an information security management system (ISMS).
            </p>
          </div>
        </div>
      </div>

      <Newfooter />
    </div>
  )
}

export default Certificate
